import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "card-mark--sprite",
  "use": "card-mark--sprite-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"card-mark--sprite\">\n<path d=\"M8.5 1.5H3.5C2.95 1.5 2.505 1.95 2.505 2.5L2.5 10.5L6 9L9.5 10.5V2.5C9.5 1.95 9.05 1.5 8.5 1.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol